import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-marine-manager-issues-template',
  templateUrl: './marine-manager-issues-template.component.html',
  styleUrls: ['./marine-manager-issues-template.component.scss'],
  standalone: false,
})
export class MarineManagerIssuesTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateFormat = DEFAULT_DATE_TIME_FORMAT;
}
